import { AuthApis } from "../apis/AuthApis";

export const AuthServices = {
  fetchUserData: async () => {
    try {
      const response = await AuthApis.fetchUserApi();
      const {
        first_name,
        last_name,
        email,
        patient_id,
        phone,
        profile_picture,
      } = response.data?.data.user;
      localStorage.setItem(
        "user",
        JSON.stringify({ first_name, last_name, email, patient_id, phone, profile_picture })
      );
      return {
        message: "USER_FETCHED",
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        message: "USER_FETCH_FAILED",
        status: error.response?.status || 500,
        data: error.response?.data || { error: "Unknown error occurred" },
      };
    }
  },

  loginUser: async (data) => {
    try {
      const response = await AuthApis.loginUserApi(data);
      return {
        message: response.message,
        status: response.status,
      };
    } catch (error) {
      const status = error.response?.status || 500;
      const message =
        error.response?.data?.message ||
        "Something went wrong. Please try again.";
      const errorData = error.response?.data || {
        error: "Unknown error occurred",
      };

      return {
        message,
        status,
        data: errorData,
      };
    }
  },

  sendOtp: async (data) => {
    try {
      const response = await AuthApis.sendOtpApi(data);
      return {
        message: "Otp SENT to Email",
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        message: "OTP Failed to send",
        status: error.response?.status || 500,
        data: error.response?.data || { error: "Unknown error occurred" },
      };
    }
  },

  googleLogin: async (data) => {
    try {
      const response = await AuthApis.googleLogin(data);
      const guser = response.data.user;
      // Split full name into firstName and lastName
      const [first_name, ...lastNameParts] = guser.name.trim().split(" ");
      const last_name = lastNameParts.join(" "); // join remaining parts as last name
      const profile_picture =
      guser.picture || guser.profile_picture || guser.imageUrl || "";

      const basicUser = {
                        ...guser,
                        first_name,
                        last_name,
                        profile_picture,};
                        
      localStorage.setItem("basic-user", JSON.stringify(basicUser));

      return {
        message: "GOOGLE_LOGIN_SUCCESS",
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      console.error("Google login error:", error);
      return {
        message: "GOOGLE_LOGIN_FAILED",
        status: error.response?.status || 500,
        data: error.response?.data || { error: "Unknown error occurred" },
      };
    }
  },

  verifyOtp: async (data) => {
    try {
      const response = await AuthApis.verifyOtpApi(data);
      return {
        message: "OTP_VERIFIED",
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        message: "OTP_VERIFICATION_FAILED",
        status: error.response?.status || 500,
        data: error.response?.data || { error: "Unknown error occurred" },
      };
    }
  },

  generateInsightsApi: async (patient_id) => {
    try {
      const response = await AuthApis.generateInsightsApi(patient_id);
      return {
        message: "Patient Insights generated successfully",
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        message: "Patient Insights generation failed",
        status: error.response?.status || 500,
        data: error.response?.data || { error: "Unknown error occurred" },
      };
    }
  },

  generateSummaryApi: async (patient_id,conversation_id,current_persona) => {
    try {
      const response = await AuthApis.generateSummaryApi(patient_id,conversation_id,current_persona);
      return {
        message: "conversation summary generated successfully",
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        message: "conversation summary generation failed",
        status: error.response?.status || 500,
        data: error.response?.data || { error: "Unknown error occurred" },
      };
    }
  },


  logout: async () => {
    try {
      const response = await AuthApis.logout();
      return {
        message: "Logout successful",
        status: response.status,
      };
    } catch (error) {
      return {
        message: "Logout failed, please try again.",
        status: error.response?.status || 500,
        data: error.response?.data || { error: "Unknown error occurred" },
      };
    }
  },
};
